module.exports = __webpack_public_path__ + "static/media/cekarna2.ca937bc5.jpg";